import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { isEmpty } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class PageTitleStrategy extends TitleStrategy {
  readonly #title = inject(Title);
  readonly #translateService = inject(TranslateService);

  updateTitle(routerState: RouterStateSnapshot): void {
    this.setTitle(this.buildTitle(routerState));
  }

  setTitle(pageTitle?: string): void {
    if (isEmpty(pageTitle)) {
      return;
    }

    this.#title.setTitle(this.#translateService.instant(pageTitle));
  }
}
